var _circle, _circle2, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCart2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.625,
    cy: 14.375,
    r: 1.125,
    fill: "#2F4DC4"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.125,
    cy: 14.375,
    r: 1.125,
    fill: "#2F4DC4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 5.75L2.25 5.75",
    stroke: "#2F4DC4",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 10.25L3 10.25",
    stroke: "#2F4DC4",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 8L1.5 8",
    stroke: "#2F4DC4",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.07143 3.875L6.56774 10.5769C6.72082 11.2625 7.32921 11.75 8.0317 11.75H13.5397C14.2422 11.75 14.8506 11.2625 15.0037 10.5769L16.0921 5.70186C16.3014 4.76469 15.5884 3.875 14.6282 3.875H5.07143ZM5.07143 3.875L4.65814 2.35616C4.48045 1.70315 3.88751 1.25 3.21077 1.25H1.5",
    stroke: "#2F4DC4",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart2);
export default __webpack_public_path__ + "static/media/cart2.5a8ec702b57fdef1c130c32b84634453.svg";
export { ForwardRef as ReactComponent };